import { render } from "./OfferCard.vue?vue&type=template&id=5f4ff0be&scoped=true"
import script from "./OfferCard.vue?vue&type=script&lang=js"
export * from "./OfferCard.vue?vue&type=script&lang=js"

import "./OfferCard.vue?vue&type=style&index=0&id=5f4ff0be&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4ff0be"]])

export default __exports__